import React, { useState } from "react";
import {
  Col,
  Row,
  Typography, Layout, Button,
  Card, Image, Modal
} from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { ImageUrl } from "../../helpers/Functions";
import { Link } from "react-router-dom";

function Homepage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [modal2Open, setModal2Open] = useState(false);

  // useEffect if user is already logged in
  React.useEffect(() => {
    if (!user && !token) {
      navigate("/", { replace: true });
    }
  }, [user, token, navigate]);

  const stories = [
    {
      id: 1,
      title: "Transforming Training: How RTI Thrived with WrightCo Academy's LMS",
      image: "new-92.png",
    },
    {
      id: 2,
      title: "Innovative Learning: Revolutionizing Employee Development",
      image: "new-93.png",
    },
    {
      id: 3,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-94.png",
    },
    {
      id: 4,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-95.png",
    },
    {
      id: 5,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-96.png",
    },
    {
      id: 6,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-97.png",
    },
    {
      id: 7,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-98.png",
    },
    {
      id: 8,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-99.png",
    },
    {
      id: 9,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-100.png",
    },
    {
      id: 10,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-101.png",
    },
    // Add more stories as needed
  ];
  return (
    <Layout style={{ minHeight: "100vh", backgroundSize: "cover" }}>
      <section>
        <Row className="cource-banner" justify={"center"} align={"middle"}>
          <Col xs={24} md={10}>
            <div className="">
              <Row style={{ width: "100%", justifyContent: "center" }}>
                <Col xs={20} md={20} className="formWrap">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("miniImg3.png")}
                  />
                  <p className="text-p-14">Customer Stories</p>
                  <Typography.Title
                    className="fontFamily1 smallTitle"
                    style={{ color: "#fff" }}
                  >
                    {
                      <>
                        {" "}
                        Read How Our Customers Manage Training And Grow Their
                        Businesses
                      </>
                    }
                  </Typography.Title>

                  <Typography.Text
                    className="fontFamily1 smallText"
                    style={{ color: "#fff" }}
                  >
                    Learn how our customers manage professional development with
                    AOM: Training Customers, Businesses, and Employees. Say no
                    more to cookie-cutter platforms with poor support!
                  </Typography.Text>
                  <br />
                  <br />
                  <br />
                  {!token && <Button
                    type="primary"
                    htmlType="submit"
                    className="whiteButton"
                    onClick={() => navigate("/signup")}
                    style={{ marginLeft: "5px" }}
                  >
                    Register Now
                  </Button>}
                </Col>
              </Row>
            </div>
          </Col>

          <Col xs={0} sm={0} md={12}>
            <div className="" style={{ textAlign: "center" }}>
              <Row style={{ width: "100%", paddingRight: "20px" }} gutter={40}>
                <Col xs={0} sm={12} md={24}>
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("new-90.png")}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </section>

      <section className="bg-white top-bottom-padding">
        <Row justify={"center"} style={{ textAlign: "center" }}>
          <Col xl={10} lg={12}>
            <Image
              preview={false}
              alt={"Failed to load image"}
              src={ImageUrl("miniImg2.png")}
            />
            <h4 className="text-38">
              What Do Customers Love About WrightCo Academy?
            </h4>
          </Col>
        </Row>
        <Row justify={"center"} style={{ padding: "10px 0" }}>
          <Col lg={20}>
            <Row
              justify={"center"}
              align={"middle"}
              gutter={[32, 32]}
              className="gutter-0"
            >
              <Col xs={24} sm={24} md={12}>
                <div className="">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("new-91.png")}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>

      <section className="bg-white top-bottom-padding">
        <Row justify={"center"} style={{ textAlign: "center" }}>
          <Col xl={10} lg={12}>
            <Image
              preview={false}
              alt={"Failed to load image"}
              src={ImageUrl("miniImg2.png")}
            />
            <h4 className="text-38">More Customer Stories</h4>
            <p className="text-p-16">
              Read how our customers use WrightCo Academy to manage eLearning,
              scale Professional Development, and sell courses B2B and B2C.
            </p>
          </Col>
        </Row>
      </section>

      <section className="bg-gray top-bottom-padding">
        <Row justify={"center"} style={{ padding: "10px 0" }}>
          <Col lg={16}>
            <Row
              justify={"center"}
              align={"middle"}
              gutter={[32, 32]}
              className="gutter-0"
            >
              {stories.map((story, index) => (
                <Col key={index} xs={24} sm={24} md={10}>
                  <Link target="_blank" to={"https://wrightcoblog.com/"}>
                  <div className="stories-cards">
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      src={ImageUrl(story.image)}
                    />
                    <div className="stories-cards-content">
                      <h5>{story.title}</h5>
                    </div>
                  </div>
                  </Link>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </section>

      <section className="bg-white top-bottom-padding">
        <Row justify={"center"}>
          <Col xl={18} lg={17} md={23} xs={23}>
            <div className="on-demand">
              <h4>Efficiently Sell Courses & Webinars Online</h4>
              {!token &&<Button
                type="primary"
                htmlType="submit"
                className="whiteButton"
                onClick={() => navigate("/signup")}
                style={{ marginLeft: "5px" }}
              >
                Get Started
              </Button>}
            </div>
          </Col>
        </Row>
      </section>
      <Row
        className="whiteBackground"
        style={{ backgroundColor: "white", justifyContent: "center" }}
      >
        <Modal
          // title="Vertically centered modal dialog"
          centered
          open={modal2Open}
          onOk={() => setModal2Open(false)}
          onCancel={() => setModal2Open(false)}
          width={1000}
          footer={false}
        >
          <div
            style={{
              padding: "50px 20px",
            }}
          >
            <video width="auto" height="auto" controls>
              <source
                src={`https://react.customdev.solutions:3012/Uploads/tutorVideo.mp4`}
              />
              <source src="movie.ogg" type="video/ogg" />
            </video>
          </div>
        </Modal>
        {/* <Col xs={24} md={16}>
          <div
            style={{
              padding: "50px 20px",
            }}
          >
            <video width="auto" height="auto" controls>
              <source src={`https://react.customdev.solutions:3012/Uploads/tutorVideo.mp4`} />
              <source src="movie.ogg" type="video/ogg" />
            </video>
          </div>
        </Col> */}
        {/* <Col xs={24} md={16}>
          <div style={{ position: "relative" }}>
            <Link target="_blank" to="https://trainer.wrightcoacademy.com/signup" style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                className="loginButton"
                style={{ position: "absolute", top: "0", right: "0", left: "0", bottom: "0", margin: "auto", zIndex: "999", maxWidth: "200px" }}
              >
                Join us as a Trainer
              </Button>
            </Link>
            <Image src={ImageUrl('Trainer.jpeg')} preview={false} />
          </div>
        </Col> */}
        <Col xs={24} md={16}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",

              padding: "50px 20px",
            }}
          >
            <Card
              className="contactCard1 terms-box"
              bordered={false}
              style={{
                width: "100%",
                padding: "20px",
              }}
            >
              <h3> We’re Looking for Trainers</h3>
              <h3>Teach. Create. Earn.</h3>
              <p>
                {" "}
                Are you passionate about teaching? Ready to share your
                expertise, connect with professionals, and make a meaningful
                impact, all while earning extra income?
              </p>

              <h4> You've come to the right place.</h4>
              <p>
                {" "}
                At WrightCo Academy, we are building a network of world-class
                trainers and industry experts dedicated to developing
                high-quality courseware for professionals in early care and
                education. If you’re an expert in your field with a desire to
                teach, we’d love to have you on board!
              </p>

              <h3> Why Join Us?</h3>
              <ul>
                <li>
                  <p>
                    ✅ Expand Your Reach – Share your knowledge with a broad
                    audience of professionals.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Boost Your Visibility – Gain recognition as a trusted
                    expert in your industry.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Join a Thriving Community – Connect with like-minded
                    trainers and industry leaders.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Earn Passive Income – Our fair and flexible
                    revenue-sharing model ensures unlimited earning potential.
                  </p>
                </li>
              </ul>

              <h3> What It Takes to Be a WrightCo Trainer</h3>
              <ul>
                <li>
                  <p>
                    ✔ <strong>Passion for Teaching</strong> – A commitment to
                    sharing knowledge and empowering others.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Industry Expertise</strong> – Relevant
                    certifications and experience in your domain.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Strong Communication Skills</strong> – Ability to
                    present information effectively.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Commitment to Excellence</strong> – Willingness to
                    develop and deliver high-quality training.
                  </p>
                </li>
              </ul>
              <h4> Ready to Make an Impact?</h4>
              <p>
                {" "}
                Join WrightCo Academy today and take the next step in your
                teaching journey.
              </p>
            </Card>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default Homepage;
